import $ from 'jquery';
import _ from 'underscore';
import autosize from 'lib/autosize';
import ajax from 'util/ajax';
import { initAutosubmit } from 'util/autosubmit';
import { CLASS_NAME_DISABLED, CLASS_NAME_EXPANDED } from 'util/constants';
import * as deferred from 'util/deferred';
import { $body, $window, jqGetElemByCmpName, jqGetElemById, jqOffOn } from 'util/global';
import { Anchors, isInViewport } from 'util/ui';
import comments from 'app/comments';
import { initGenericControllers } from 'app/generic_controllers';
import contentModal from 'app/content_modal';

const discussions = {};

// May want to consider changing all `vkey` to `window.vkey` in this file
const { vkey } = window; // this is created by importing ajax

var init = function ($container = $body) {
  comments.events($container);
  comments.expander($container);
  comments.subscribe($container);

  const $subscriptionPlaceholder = jqGetElemById('subscr-placeholder');
  if ($subscriptionPlaceholder.length) {
    jqGetElemByCmpName('discussions_subscribe')
      .appendTo($subscriptionPlaceholder)
      .removeClass('hide');
  }
};

var discussion_events = function () {
  const $editForm = $('#edit_post_form_id');
  const $discussionPost = $('#disc-post-single');
  const $textarea = $('.edit-form textarea', $discussionPost);

  autosize($textarea);

  const SCOPED_CLICK = 'click.discussionpreview';

  // edit main button
  jqOffOn($('#newdisc-edit'), SCOPED_CLICK, e => {
    e.preventDefault();
    $discussionPost.addClass('editing');
    $textarea.trigger('autosize.resize');
  });

  // delete main button
  jqOffOn($('#newdisc-delete'), SCOPED_CLICK, e => {
    e.preventDefault();
    $discussionPost.addClass('deleting');
  });

  // preview submit button
  jqOffOn($editForm.find('.preview:not(.fake)'), SCOPED_CLICK, e => {
    e.preventDefault();
    $window.trigger($.Event(`discussion.preview.${$editForm.prop('id') || -1}`));
    ajax('discussions_single').form($editForm[0], {
      preview_post: true,
    });
  });

  // edit submit button
  jqOffOn($editForm.find('.edit:not(.fake)'), SCOPED_CLICK, e => {
    e.preventDefault();
    $discussionPost.addClass('editing');
    $discussionPost.removeClass('previewing');
    $textarea.trigger('autosize.resize');
  });

  // delete cancel button
  jqOffOn($('#delete-cancel'), SCOPED_CLICK, e => {
    e.preventDefault();
    $discussionPost.removeClass('deleting');
  });
};

/**
 * Controller for discussion pages (notes + notes in sets)
 * @param {JQuery} $container
 */
discussions.onload = function ($container) {
  init($container);
  discussion_events();

  if (window.location.search.indexOf('unsubscribe_from_post=true') >= 0) {
    // highlight unsubscribe link
    const $unsubComponent = jqGetElemByCmpName('discussions_subscribe');
    $unsubComponent.addClass('wiggle');
    _.defer(() => {
      Anchors.scrollToTarget($unsubComponent);
    });
  } else {
    // highlight comment
    var hashMatch = window.location.hash.match(/#comment-a3f5[\d]+e92/);
    if (hashMatch) {
      var $target = $(hashMatch[0]);
      comments.expandThreadsFor($target);
      $target.addClass('highlight');
      setTimeout(function () {
        $target.removeClass('highlight');
      }, 3000);
    }
  }
};

/**
 * Controller for editable title
 * @param {JQuery} $title
 */
discussions.editableTitle = function ($title) {
  var $editTitleLink = $title.find('.edit-title-link'),
    $editTitleForm = $title.parent().find('.edit-title-form'),
    $cancelLink = $editTitleForm.find('.cancel-edit-link');

  $editTitleLink.add($cancelLink).on('click', function () {
    $title.add($editTitleForm).toggleClass('hide');
  });
};

/**
 * Controller for a button that expands/collapses all comment threads.
 * Note: it is currently used in daily problems discussions only and probably will need some
 *       adjustments in order for it to work for other types of discussions.
 * @param {JQuery} $button
 */
discussions.expandAllThreads = $button => {
  /** @param {Boolean} expand */
  const toggleAllThreads = expand => {
    $(expand ? '.show-replies' : '.hide-replies').trigger('click');
    $button.toggleClass(CLASS_NAME_EXPANDED, expand);
  };

  const loadAllSolutions = () =>
    new Promise(resolve => {
      const loadMoreSolutionsOrResolve = () => {
        if ($('.solution-next-page').length > 0) {
          $window.trigger('scroll.loadMoreSolutionsButton', { force: true });
        } else {
          resolve();
        }
      };
      $window.on('moreSolutionsLoaded', loadMoreSolutionsOrResolve);
      loadMoreSolutionsOrResolve();
    });

  const loadAllComments = () =>
    new Promise(resolve => {
      const cmpSelector = '.discsol-comments .cmp-deferred';
      const $cmps = $(cmpSelector);

      $window.on('solutions.reload', () => {
        if ($(cmpSelector).length === 0) {
          resolve();
        }
      });
      if ($cmps.length > 0) {
        $cmps.each((i, cmp) => {
          deferred.load($(cmp));
        });
      } else {
        resolve();
      }
    });

  $button.on('click', () => {
    const expanded = $button.hasClass(CLASS_NAME_EXPANDED);

    if (expanded) {
      toggleAllThreads(false);
    } else {
      $button.addClass(CLASS_NAME_DISABLED);
      loadAllSolutions()
        .then(loadAllComments)
        .then(() => {
          toggleAllThreads(true);
          $button.removeClass(CLASS_NAME_DISABLED);
        });
    }
  });
};

// version handling
// --------------------------------------------------

vkey.qanda_subscribe =
  vkey.course_feedback_subscribe =
  vkey.contentreports_subscribe =
    function () {
      vkey.handle.apply(this, arguments);
      comments.subscribe();
    };

module.exports = discussions;
